// Single source of truth for fake SDK/JWT constants.
// Imported by handlers.ts (MSW) and e2e/payment/payment.spec.js (Playwright) — edit once, both transports update.

// Fake CyberSource session JWT: header={"alg":"none"}, payload points clientLibrary to
// testmicroform.example.com/flex.js. clientLibraryIntegrity="" disables SRI.
// Built from literal objects so the base64 payload stays in sync with the clientLibrary URL.
// Uses base64→base64url conversion (remove padding, replace +/ with -_) for browser compat:
// Buffer.toString('base64url') is not supported by webpack's browser Buffer polyfill.
const toBase64url = str => Buffer.from(str).toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
const FAKE_JWT_HEADER  = toBase64url(JSON.stringify({ alg: 'none' }))
const FAKE_JWT_PAYLOAD = toBase64url(JSON.stringify({
  ctx: [{ data: { clientLibrary: 'https://testmicroform.example.com/flex.js', clientLibraryIntegrity: '' } }]
}))
const FAKE_JWT = `${FAKE_JWT_HEADER}.${FAKE_JWT_PAYLOAD}.`

// Fake Flex SDK served at the clientLibrary URL decoded from FAKE_JWT.
// maskedValue='1111' is obviously synthetic. The btoa() token format matches what
// DPaymentMethod.onStepNavigation decodes from the transient token.
const FAKE_FLEX_SDK = `
window.Flex = function(jwt) {
  this.microform = function(container, options) {
    return {
      createField: function(type, opts) { return { load: function(selector) {} }; },
      createToken: function(options, callback) {
        var payload = JSON.stringify({
          content: {
            paymentInformation: {
              card: { number: { maskedValue: '1111', detectedCardTypes: ['001'] } }
            }
          }
        });
        callback(null, 'fake.' + btoa(payload) + '.sig');
      }
    };
  };
};
`

// Fake Accept.js served at both Authorize.net CDN URLs.
// Sets window.Accept and fires the 'handshake' event that loadAcceptJs() listens for.
const FAKE_ACCEPT_JS = `
window.Accept = {};
document.body.dispatchEvent(new Event('handshake'));
`

module.exports = { FAKE_JWT, FAKE_FLEX_SDK, FAKE_ACCEPT_JS }
